module.exports = __webpack_public_path__ + "img/mirror-battle-menu-icon.047d0275.png";